"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.ProofType = exports.FactorType = exports.FederatedAuthType = exports.ClassicIdType = exports.Realm = exports.Action = void 0;
var Action;
(function (Action) {
    Action["LOGGED_IN"] = "LOGGED_IN";
    Action["PASSWORD_RESET_REQUESTED"] = "PASSWORD_RESET_REQUESTED";
    Action["IDENTITY_CREATED"] = "IDENTITY_CREATED";
    Action["IDENTITY_DELETED"] = "IDENTITY_DELETED";
    Action["IMPERSONATED"] = "IMPERSONATED";
    Action["MULTIFACTOR_ADDED"] = "MULTIFACTOR_ADDED";
    Action["MULTIFACTOR_DELETED"] = "MULTIFACTOR_DELETED";
    Action["MULTIFACTOR_MADE_PRIMARY"] = "MULTIFACTOR_MADE_PRIMARY";
    Action["PASSWORD_UPDATED"] = "PASSWORD_UPDATED";
    Action["PASSWORDS_INVALIDATED"] = "PASSWORDS_INVALIDATED";
    Action["EMAIL_ADDED"] = "EMAIL_ADDED";
    Action["EMAIL_REMOVED"] = "EMAIL_REMOVED";
    Action["EMAIL_UPDATED"] = "EMAIL_UPDATED";
    Action["EMAILS_REPLACED"] = "EMAILS_REPLACED";
    Action["USERNAME_ADDED"] = "USERNAME_ADDED";
    Action["USERNAME_REMOVED"] = "USERNAME_REMOVED";
    Action["USERNAME_UPDATED"] = "USERNAME_UPDATED";
    Action["REFERRER_UPDATED"] = "REFERRER_UPDATED";
    Action["FEDERATED_ID_UPDATED"] = "FEDERATED_ID_UPDATED";
    Action["FEDERATED_ID_REMOVED"] = "FEDERATED_ID_REMOVED";
    Action["PASSWORD_RESET_SUCCESSFUL"] = "PASSWORD_RESET_SUCCESSFUL";
    Action["CLASSIC_ID_ADDED"] = "CLASSIC_ID_ADDED";
    Action["CLASSIC_ID_REMOVED"] = "CLASSIC_ID_REMOVED";
    Action["DELETED"] = "DELETED";
})(Action = exports.Action || (exports.Action = {}));
var Realm;
(function (Realm) {
    Realm["User"] = "User";
    Realm["Machine"] = "Machine";
    Realm["Internal"] = "Internal";
    Realm["Partner"] = "Partner";
    Realm["GroupAdmin"] = "GroupAdmin";
})(Realm = exports.Realm || (exports.Realm = {}));
var ClassicIdType;
(function (ClassicIdType) {
    ClassicIdType["Member"] = "Member";
    ClassicIdType["Associate"] = "Associate";
    ClassicIdType["Dependent"] = "Dependent";
})(ClassicIdType = exports.ClassicIdType || (exports.ClassicIdType = {}));
var FederatedAuthType;
(function (FederatedAuthType) {
    FederatedAuthType[FederatedAuthType["Okta"] = 0] = "Okta";
})(FederatedAuthType = exports.FederatedAuthType || (exports.FederatedAuthType = {}));
var FactorType;
(function (FactorType) {
    FactorType["GOOGLE"] = "GOOGLE";
    FactorType["SMS"] = "SMS";
    FactorType["EMAIL"] = "EMAIL";
    FactorType["ACCOUNT"] = "ACCOUNT";
    FactorType["QUESTION"] = "QUESTION";
})(FactorType = exports.FactorType || (exports.FactorType = {}));
var ProofType;
(function (ProofType) {
    ProofType["KNOWLEDGE"] = "KNOWLEDGE";
    ProofType["POSSESSION"] = "POSSESSION";
    ProofType["BIOMETRIC"] = "BIOMETRIC";
    ProofType["ACCOUNT"] = "ACCOUNT";
})(ProofType = exports.ProofType || (exports.ProofType = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://identities.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Identities API
 * @version v1
 * @baseUrl https://identities.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * @description The journal is for internal use only
             *
             * @tags IdentityJournal
             * @name IdentitiesJournalAll
             * @summary Machine JWT Only
             * @request GET:/v1/identities/journal
             * @secure
             */
            identitiesJournalAll: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description The journal is for internal use only
             *
             * @tags IdentityJournal
             * @name IdentitiesJournal
             * @summary Machine JWT Only
             * @request GET:/v1/identities/journal/maxClock
             * @secure
             */
            identitiesJournal: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Identities
             * @name IdentitiesFindByIdentityId
             * @request GET:/v1/identities/{identityId}
             * @secure
             */
            identitiesFindByIdentityId: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Identities
             * @name IdentitiesRemoveIdentity
             * @request DELETE:/v1/identities/{identityId}
             * @secure
             */
            identitiesRemoveIdentity: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}`, method: 'DELETE', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Identities
             * @name IdentitiesIndex
             * @request GET:/v1/identities
             * @secure
             */
            identitiesIndex: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Identities
             * @name IdentitiesCreateIdentity
             * @request POST:/v1/identities
             * @secure
             */
            identitiesCreateIdentity: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Identities
             * @name IdentitiesImpersonate
             * @request POST:/v1/identities/{identityId}/impersonate
             * @secure
             */
            identitiesImpersonate: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/impersonate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Identities
             * @name IdentitiesMigrateIdentity
             * @request POST:/v1/identities/migrate
             * @secure
             */
            identitiesMigrateIdentity: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/migrate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Identity
             * @name ExternalBasicAuthorization
             * @request GET:/v1/identityExists
             * @secure
             */
            externalBasicAuthorization: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identityExists`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Keys
             * @name KeysFetchKey
             * @request GET:/v1/keys/{keyId}
             * @secure
             */
            keysFetchKey: (keyId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/keys/${keyId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Multifactor
             * @name MultifactorGetMultifactorType
             * @request GET:/v1/identities/{identityId}/settings
             * @secure
             */
            multifactorGetMultifactorType: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/settings`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Multifactor
             * @name MultifactorUpdateMultifactorType
             * @request POST:/v1/identities/{identityId}/settings
             * @secure
             */
            multifactorUpdateMultifactorType: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/settings`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Passwords
             * @name PasswordsUpdateCredential
             * @request POST:/v1/users/{identityId}/passwords
             * @deprecated
             * @secure
             */
            passwordsUpdateCredential: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/passwords`, method: 'POST', body: data, secure: true, type: FecContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Passwords
             * @name PasswordsResetPassword
             * @request POST:/v1/identities/{identityId}/resetPassword
             * @secure
             */
            passwordsResetPassword: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/resetPassword`, method: 'POST', body: data, secure: true, type: FecContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Passwords
             * @name PasswordsUpdatePassword2
             * @request POST:/v1/identities/{identityId}/updatePassword
             * @deprecated
             * @secure
             */
            passwordsUpdatePassword2: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/updatePassword`, method: 'POST', body: data, secure: true, type: FecContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Passwords
             * @name PasswordsBulkAddPasswords
             * @request POST:/v1/identities/{identityId}/bulkAddPasswords
             * @secure
             */
            passwordsBulkAddPasswords: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/bulkAddPasswords`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Passwords
             * @name PasswordsInvalidatePasswords
             * @request POST:/v1/identities/{identityId}/invalidatePasswords
             * @secure
             */
            passwordsInvalidatePasswords: (identityId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/invalidatePasswords`, method: 'POST', query: query, secure: true }, params)),
            /**
             * No description
             *
             * @tags Passwords
             * @name PasswordsSetPassword
             * @request POST:/v1/setPassword
             * @secure
             */
            passwordsSetPassword: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/setPassword`, method: 'POST', body: data, secure: true, type: FecContentType.Json }, params)),
            /**
             * No description
             *
             * @tags SendPasswordResetEmail
             * @name SendPasswordResetEmailPostPasswordResetToken
             * @request POST:/v1/sendPasswordResetEmail
             * @secure
             */
            sendPasswordResetEmailPostPasswordResetToken: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/sendPasswordResetEmail`, method: 'POST', body: data, secure: true, type: FecContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Tokens
             * @name TokensPostJwtToken
             * @request POST:/v1/tokens
             * @secure
             */
            tokensPostJwtToken: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/tokens`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ClassicId
             * @name ClassicIdAddClassicId
             * @request POST:/v1/identities/{identityId}/addClassicId
             * @secure
             */
            classicIdAddClassicId: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/addClassicId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ClassicId
             * @name ClassicIdRemoveClassicId
             * @request POST:/v1/identities/{identityId}/removeClassicId
             * @secure
             */
            classicIdRemoveClassicId: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/removeClassicId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Email
             * @name EmailAddEmail
             * @request POST:/v1/identities/{identityId}/addEmail
             * @secure
             */
            emailAddEmail: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/addEmail`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Email
             * @name EmailRemoveEmail
             * @request POST:/v1/identities/{identityId}/removeEmail
             * @secure
             */
            emailRemoveEmail: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/removeEmail`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Email
             * @name EmailUpdateEmail
             * @request POST:/v1/identities/{identityId}/updateEmail
             * @secure
             */
            emailUpdateEmail: (identityId, query, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/updateEmail`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Email
             * @name EmailReplaceAllEmails
             * @request POST:/v1/identities/{identityId}/replaceAllEmails
             * @secure
             */
            emailReplaceAllEmails: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/replaceAllEmails`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Referrer
             * @name ReferrerUpdateReferrer
             * @request POST:/v1/identities/{identityId}/updateReferrer
             * @secure
             */
            referrerUpdateReferrer: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/updateReferrer`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags SocialProvider
             * @name SocialProviderUpdateOktaId
             * @request POST:/v1/identities/{identityId}/updateOktaId
             * @secure
             */
            socialProviderUpdateOktaId: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/updateOktaId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags SocialProvider
             * @name SocialProviderRemoveOktaId
             * @request DELETE:/v1/identities/{identityId}/okta
             * @secure
             */
            socialProviderRemoveOktaId: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/okta`, method: 'DELETE', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Username
             * @name UsernameAddUsername
             * @request POST:/v1/identities/{identityId}/addUsername
             * @secure
             */
            usernameAddUsername: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/addUsername`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Username
             * @name UsernameRemoveUsername
             * @request POST:/v1/identities/{identityId}/removeUsername
             * @secure
             */
            usernameRemoveUsername: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/removeUsername`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Username
             * @name UsernameUpdateUsername
             * @request POST:/v1/identities/{identityId}/updateUsername
             * @secure
             */
            usernameUpdateUsername: (identityId, query, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/updateUsername`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
        this.v2 = {
            /**
             * No description
             *
             * @tags Passwords
             * @name PasswordsUpdatePassword
             * @request POST:/v2/identities/{identityId}/updatePassword
             * @secure
             */
            passwordsUpdatePassword: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/updatePassword`, method: 'POST', body: data, secure: true, type: FecContentType.Json }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=identities.js.map